export namespace IFaireDirectSignupAttributionRequest {
  export enum FaireDirectSignupAttributionRelationshipType {
    FAIRE_DIRECT_SIGNUP_ATTRIBUTION_RELATIONSHIP_TYPE_UNKNOWN = 'FAIRE_DIRECT_SIGNUP_ATTRIBUTION_RELATIONSHIP_TYPE_UNKNOWN',
    INVITE = 'INVITE',
    TRADE_SHOW = 'TRADE_SHOW',
    SOCIAL_MEDIA = 'SOCIAL_MEDIA',
    SEARCH = 'SEARCH',
    OTHER = 'OTHER',
  }

  /**
   * Return an instance of IFaireDirectSignupAttributionRequest with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IFaireDirectSignupAttributionRequest>
  ): IFaireDirectSignupAttributionRequest =>
    ({
      ...(partial ?? {}),
    }) as IFaireDirectSignupAttributionRequest;
}

export interface IFaireDirectSignupAttributionRequest {
  have_purchased_from_brand: boolean | undefined;
  /**
   * havePurchasedFromBrand tracks the final response of whether they have purchased from brand, while
   * hasAnsweredNotPurchasedFromBrand tracks if at any point they answered that they have not purchased from brand
   */
  has_answered_not_purchased_from_brand: boolean | undefined;
  relationship_response:
    | keyof typeof IFaireDirectSignupAttributionRequest.FaireDirectSignupAttributionRelationshipType
    | undefined;
  other_text: string | undefined;
}
